import { SKIP, visit } from 'unist-util-visit';

import createNode from '../utils/create-node';

const keyTakeAwaysHeader = () => {
    return (tree: any) => {
        const headerNode = createNode({
            id: 'key-takeaways',
            nodeClassName:
                'flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-3 py-3 border-t border-b mb-4 flex-grow-0 flex-shrink-0 text-sm text-left uppercase text-[#5637cd]',
            tagName: 'p',
        });
        // @ts-ignore
        headerNode.children.push({ type: 'text', value: 'key takeaways' });

        visit(tree, 'element', node => {
            if (node.tagName === 'div' && node.properties?.className?.includes('highlights')) {
                node.children.unshift(headerNode);
                return [SKIP];
            }
            return [];
        });
    };
};

export default keyTakeAwaysHeader;
